import { FILTER_OP_SEPARATOR } from '@/constants/initiative'

/**
 * This serializes filterOp value to a string
 * @param field
 * @param operator
 * @param value
 * @returns {`${string}~${string}~${string}`}
 */
export default (field, operator, value) =>
  `${field}${FILTER_OP_SEPARATOR}${operator}${FILTER_OP_SEPARATOR}${JSON.stringify(value)}`
